import * as Yup from 'yup';

import { LanguageCode } from 'i18n/internationalization.types';
import { MessageLogByUid } from 'models/automation/MessageLogs';
import {
  MessagingType,
  SystemTemplate,
} from 'models/automation/SystemTemplates';

export const messageLogViewModalSchema = ({
  messagingType,
}: {
  messagingType?: MessagingType;
}) =>
  Yup.object({
    templateContent: Yup.string().richTextEditorContentRequired(),
    templateContent_htmlContent: Yup.string().required(),
    templateSubject: Yup.string().when({
      is: () => messagingType === MessagingType.EMAIL,
      then: (schema) => schema.required(),
    }),
  });

export type MessageLogViewModalFormValues = Yup.InferType<
  ReturnType<typeof messageLogViewModalSchema>
>;

export const getFormDefaultValues = ({
  messageLog,
  template,
}: {
  messageLog: MessageLogByUid;
  template?: SystemTemplate | null;
}): MessageLogViewModalFormValues => {
  const language = messageLog?.templateLanguage ?? LanguageCode.EN;
  const templateContent =
    messageLog?.templateContent ?? template?.locales?.[language]?.content;
  const templateSubject =
    messageLog?.templateTitle ?? template?.locales?.[language]?.subject;

  return {
    templateContent: templateContent ?? '',
    templateContent_htmlContent: templateContent ?? '',
    templateSubject: templateSubject ?? '',
  };
};
